/**
 * Super-admin endpoint builders (SA-1853 / SA-1854).
 *
 * Every route in this area is company-scoped through a PATH parameter, not a
 * query parameter — `/super-admin/companies/{companyID}/...`. Keeping the
 * builders in one module means a future rename touches one file.
 */
const base = (companyId) => `/super-admin/companies/${companyId}`;

export const superAdminEndpoints = {
  claimList: (companyId) => `${base(companyId)}/insurance-claims`,
  claimAnalytics: (companyId) =>
    `${base(companyId)}/insurance-claims/analytics`,
  claimDetail: (companyId, claimId) =>
    `${base(companyId)}/insurance-claims/${claimId}`,
  claimQc: (companyId, claimId) =>
    `${base(companyId)}/insurance-claims/${claimId}/qc`,
  claimQcHistories: (companyId, claimId) =>
    `${base(companyId)}/insurance-claims/${claimId}/qc-histories`,
  claimNote: (companyId, claimId, noteType) =>
    `${base(companyId)}/insurance-claims/${claimId}/note/${noteType}`,
  claimDuplicates: (companyId, claimId) =>
    `${base(companyId)}/insurance-claims/${claimId}/duplicates`,
  // SA-2149 — company-scoped twin of the customer `/duplicate-flags` route.
  claimDuplicateFlags: (companyId, claimId) =>
    `${base(companyId)}/insurance-claims/${claimId}/duplicate-flags`,
  claimPoliceBenefits: (companyId, claimId) =>
    `${base(companyId)}/insurance-claims/${claimId}/police-benefits/list`,
  claimEligibilityCheckpoints: (companyId, claimId) =>
    `${base(companyId)}/insurance-claims/${claimId}/eligibility/checkpoints`,
  claimHospitalBlockStatus: (companyId, claimId) =>
    `${base(companyId)}/insurance-claims/${claimId}/hospital/block-status`,
  claimDoctorsBlockStatus: (companyId, claimId) =>
    `${base(companyId)}/insurance-claims/${claimId}/doctors/block-status`,
  claimHetComponents: (companyId, claimId) =>
    `${base(companyId)}/insurance-claims/${claimId}/het/components`,
  claimTariffBookComponents: (companyId, claimId) =>
    `${base(companyId)}/insurance-claims/${claimId}/tariff-book/components`,
  claimMedicalRelevanceComponents: (companyId, claimId) =>
    `${base(companyId)}/insurance-claims/${claimId}/medical-relevance/components`,
  // Company-scoped master data (SA-1853). Same payloads as the customer-site
  // `/doctors`, `/insurances`, `/insurance-types`,
  // `/referral-admission-types` and `/service-classes` — the company
  // comes from the path instead of the caller's token.
  doctors: (companyId) => `${base(companyId)}/doctors`,
  insurances: (companyId) => `${base(companyId)}/insurances`,
  insuranceTypes: (companyId) => `${base(companyId)}/insurance-types`,
  referralAdmissionTypes: (companyId) =>
    `${base(companyId)}/referral-admission-types`,
  serviceClasses: (companyId) => `${base(companyId)}/service-classes`,
  organizations: (companyId) => `${base(companyId)}/organizations`,
  claimTypes: (companyId) => `${base(companyId)}/claim-types`,
};
